/**
 * The seats that have already voted in the run-it-twice window.
 *
 * Segment 0 of `runs` is the dot-separated seat list the vote handler appends to
 * as each player answers — `v3.5/2/2/0` means seats 3 and 5 have voted. The
 * engine seeds it as `v0`, which means "nobody yet", so a 0 is dropped rather
 * than counted as a voter.
 *
 * Mirrors `parseVotedSeats` in the voteMultiRun handler, which is the writer.
 * Kept deliberately permissive: an unparseable segment yields an empty list, so
 * a corrupt value shows "nobody has voted" rather than throwing inside the
 * action panel.
 */
export const parseVotedSeats = (runs?: string): number[] => {
  const segment = String(runs ?? '').split('/')[0];

  // The voting form always starts with 'v'. Requiring it keeps the other `runs`
  // shapes from parsing into nonsense — `parseInt('2,6,1')` is 2, so the
  // run-out form "2,6,1" would otherwise report seat 2 as having voted.
  if (!segment.startsWith('v')) return [];

  return segment
    .slice(1)
    .split('.')
    .map((s) => parseInt(s, 10))
    .filter((n) => Number.isInteger(n) && n > 0);
};
